// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__g1SY0","image":"Header_image__2fTBk","name":"Header_name__by2oZ","info":"Header_info__3GlPj","infoRow":"Header_infoRow__2dcPQ"};